import React from "react";
import "../App.css";
import about1 from "../assests/images/about-1.jpg";
import about2 from "../assests/images/about-2.jpg";
import vision from "../assests/images/carousel-1.jpg";
import vision1 from "../assests/images/about-2.jpg";
import WhyChooseUs from "./WhyChooseUs";
import {
  Check,
  Rocket,
  HeartHandshake,
  Scale
} from 'lucide-react';

const AboutPage = () => {
  const values = [
    { icon: Rocket, title: 'Innovation' },
    { icon: Scale, title: 'Excellence' },
    { icon: HeartHandshake, title: 'Empowerment' },
  ];
  return (
    <div className="overflow-hidden">
      {/* Hero Header */}
      <div
        className="container-fluid header-bg py-2 mb-2 wow fadeIn"
        data-wow-delay="0.1s"
        style={{
          background: `linear-gradient(rgba(2, 74, 89, 0.8), rgba(2, 74, 89, 0.9)), url(${about1})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          minHeight: "0vh",
          display: "flex",
          alignItems: "center"
        }}
      >
        <div className="container text-center py-2">
          <h1 className="display-3 text-white mb-3 animated slideInDown">
            About Statify Solutions
          </h1>
          <nav aria-label="breadcrumb animated slideInDown">
            <ol className="breadcrumb justify-content-center mb-0">
              <li className="breadcrumb-item"><a href="/" style={{ color: '#FFA916' }}>Home</a></li>
              <li className="breadcrumb-item"><a href="/" style={{ color: '#FFA916' }}>Pages</a></li>
              <li className="breadcrumb-item active text-white" aria-current="page">About</li>
            </ol>
          </nav>
        </div>
      </div>

      {/* About Section */}
      <div className="container-xxl py-2">
        <div className="container">
          <div className="row g-5 align-items-center">
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.1s">
              <div className="position-relative">
                <img
                  className="img-fluid rounded w-75"
                  src={about1}
                  alt="Our Team"
                  style={{ transform: 'rotate(-3deg)' }}
                />
                <img
                  className="img-fluid rounded w-50 position-absolute top-50 end-0"
                  src={about2}
                  alt="Office"
                  style={{ transform: 'translateY(-25%) rotate(5deg)' }}
                />
              </div>
            </div>
            <div className="col-lg-6 wow fadeInUp" data-wow-delay="0.3s">
              <div className="section-title">

                <h1 className="display-6" style={{ color: '#024A59' }}>
                  Empowering Business Transformation
                </h1>
              </div>
              <p className="mb-4" style={{ color: 'black', lineHeight: '1.8' }}>
                Statify Solutions Limited is a leading provider of enterprise-grade ERP solutions
                that transform business operations through digital innovation and strategic
                process optimization.
              </p>
              <div className="row g-3">
                {['Comprehensive ERP Solutions', 'Industry Expertise', 'Customization & Scalability', '24/7 Support'].map((item, index) => (
                  <div className="col-sm-6" key={index}>
                    <div className="d-flex align-items-center">
                      <div
                        className="icon-box rounded-circle d-flex align-items-center justify-content-center me-3"
                        style={{
                          width: '50px',
                          height: '50px',
                          backgroundColor: '#FFA916',
                          color: '#024A59'
                        }}
                      >
                        <Check size={20} color="#024A59" />
                      </div>
                      <h6 className="mb-0" style={{ color: '#024A59' }}>{item}</h6>
                    </div>
                  </div>
                ))}
              </div>

            </div>
          </div>
        </div>
      </div>

      {/* Why Choose Us */}
      <WhyChooseUs />

      {/* Core Values Section */}
      <div className="container-fluid py-2" style={{ backgroundColor: '#f8f9fa' }}>
        <div className="container">
          {/* Header */}
          <div className="text-center mb-2">
            <span
              className="d-inline-block rounded-pill px-4 py-1 mb-3"
              style={{
                backgroundColor: '#FFA916',
                color: '#024A59',
                fontSize: '0.9rem',
                fontWeight: 600,
              }}
            >
              Our Core Values
            </span>
          </div>

          {/* Value Cards (narrow + centered) */}
          <div className="row g-4 justify-content-center">
            {values.map((value, idx) => (
              <div key={idx} className="col-auto d-flex justify-content-center">
                <div className="value-card text-center">
                  <div className="icon-box mb-2">
                    <value.icon size={36} color="#FFA916" />
                  </div>
                  <h5 className="value-title">{value.title}</h5>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Vision Section */}
      <div
        className="container-fluid py-2 py-lg-8 wow fadeIn"
        data-wow-delay="0.1s"
        style={{
          background: `linear-gradient(45deg, rgba(2, 74, 89, 0.95), rgba(2, 74, 89, 0.98)), url(${vision})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundAttachment: 'fixed',
          position: 'relative',
          overflow: 'hidden'
        }}
      >
        {/* Embedded CSS */}
        <style>
          {`
    .value-card {
  background: white;
  border: 2px solid #024A59;
  width: 200px; 
  height: 70%;
  margin: 0;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.value-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(2, 74, 89, 0.1);
}

/* icon and title styling unchanged */
.icon-box { /* ... */ }
.value-title { /* ... */ }


      @keyframes slideUp {
        to { opacity: 1; transform: translateY(0); }
      }
      @keyframes iconShake {
        0%, 100% { transform: rotate(0deg); }
        25% { transform: rotate(5deg); }
        75% { transform: rotate(-5deg); }
      }
      .hover-scale:hover { transform: scale(1.02); }
      .icon-shake { animation: iconShake 1.5s ease-in-out infinite; }
      .hover-tilt:hover { transform: rotate(1deg) scale(1.02); }
      .scale-hover:hover { transform: scale(1.05); }
    `}
        </style>

        <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 15px' }}>
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '30px', alignItems: 'center' }}>
            <div style={{ flex: '1 1 45%', minWidth: '300px', paddingRight: '30px' }}>
              <span style={{
                display: 'inline-block',
                borderRadius: '50px',
                padding: '8px 24px',
                marginTop: '24px',
                marginBottom: '24px',
                backgroundColor: 'rgba(255, 169, 22, 0.9)',
                color: '#024A59',
                fontWeight: '600',
                letterSpacing: '0.5px',
                transform: 'translateY(-10px)',
                opacity: 0,
                animation: 'slideUp 0.6s ease-out 0.3s forwards'
              }}>
                Our Vision
              </span>

              <p style={{
                fontSize: '1rem',
                lineHeight: '1.6',
                color: 'white',
                marginBottom: '32px',
                textShadow: '0 2px 4px rgba(0,0,0,0.1)'
              }}>
                To be the foremost global provider of transformative software solutions.
                We aspire to redefine the technological landscape by consistently
                delivering cutting-edge solutions that empower businesses to
                thrive in an ever-evolving digital era.
              </p>

              <span style={{
                display: 'inline-block',
                borderRadius: '50px',
                padding: '8px 24px',
                marginBottom: '24px',
                backgroundColor: 'rgba(255, 169, 22, 0.9)',
                color: '#024A59',
                fontWeight: '600',
                letterSpacing: '0.5px',
                transform: 'translateY(-10px)',
                opacity: 0,
                animation: 'slideUp 0.6s ease-out 0.3s forwards'
              }}>
                Our Mission
              </span>

              <p style={{
                fontSize: '1rem',
                lineHeight: '1.6',
                color: 'white',
                marginBottom: '32px',
                textShadow: '0 2px 4px rgba(0,0,0,0.1)'
              }}>
                To relentlessly pursue innovation, offering a diverse suite of software solutions that transcend boundaries and propel organizations toward unparalleled success. We are committed to understanding and addressing the unique challenges of businesses across various industries, fostering growth, efficiency, and sustainability.
              </p>
            </div>

            <div style={{
              flex: '1 1 45%',
              minWidth: '300px',
              perspective: '1000px'
            }} className="hover-tilt">
              <div style={{
                borderRadius: '16px',
                overflow: 'hidden',
                transform: 'rotateY(-5deg)',
                boxShadow: '25px 25px 0 0 rgba(255,169,22,0.25)',
                border: '3px solid rgba(255,169,22,0.2)',
                transition: 'all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)'
              }}>
                <img
                  src={vision1}
                  alt="Vision"
                  style={{
                    width: '100%',
                    height: 'auto',
                    borderRadius: '14px',
                    transition: 'transform 0.3s ease'
                  }}
                  className="scale-hover"
                />
                <div style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  right: 0,
                  bottom: 0,
                  background: 'linear-gradient(45deg, rgba(2, 74, 89, 0.1), rgba(255, 169, 22, 0.05))'
                }} />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* CTA Section */}
      <div className="container-fluid py-2 bg-light">
        <div className="container text-center wow fadeInUp" data-wow-delay="0.1s">
          <div className="row justify-content-center">
            <div className="col-lg-8">
              <h1 className="display-6 mb-4" style={{ color: 'black', fontFamily: 'serif', fontStyle: 'italic' }}>
                Ready to Transform Your Business?
              </h1>
              <p className="mb-4 lead" style={{ color: 'black', fontStyle: 'oblique' }}>
                Let's discuss how we can help you achieve operational excellence through
                intelligent enterprise solutions.
              </p>
              <a
                href="/contact"
                className="btn btn-primary px-5 py-3"
                style={{
                  backgroundColor: '#024A59',
                  color: '#FFA916',
                  border: 'none',
                  transition: 'all 0.3s'
                }}
                onMouseOver={(e) => {
                  e.target.style.backgroundColor = '#FFA916';
                  e.target.style.color = '#024A59';
                }}
                onMouseOut={(e) => {
                  e.target.style.backgroundColor = '#024A59';
                  e.target.style.color = '#FFA916';
                }}
              >
                Schedule Consultation
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;